<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ARHUD/ARHUD.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">抬头显示器 AR-HUD</div>
                <div class="detail-banner-desc">
                    基于 LCOS PGU 的增强现实抬头显示器（AR-HUD）凭借其核心优势，重新定义了驾驶信息的呈现方式，这些优势包括超高清显示（分辨率达 1920×1080，支持 2K/4K 升级）、大视场角（FOV 13°×4°）、紧凑尺寸（11 升）以及高亮度（13000 尼特）；<br />
                    凭借高分辨率和宽视场角设计，LCOS AR-HUD 能够将真实路况与虚拟信息完美融合，实时显示导航指引、智能驾驶辅助提示和关键驾驶数据，大幅提升驾驶安全性。此外，该系统还支持音视频娱乐信息显示，兼顾实用性与趣味性；<br />
                    与传统抬头显示器（HUD）相比，LCOS AR-HUD 在清晰度、亮度和人机交互体验方面实现了全面升级，无需驾驶员频繁低头查看仪表盘，减少分心，打造更安全、更智能的未来座舱体验。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            高亮度：亮度13000nit
                        </div>
                        <div>
                            体积：体积11L
                        </div>
                        <div>
                            成像单元：LCOS（华为H300）
                        </div>
                        <div>
                            增强现实：虚实融合，动态指引，提升驾驶安全性
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ARHUD/ARHUD-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">13° x 4°</div>
                                    <div class="k">视场角</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">VID 10m</div>
                                    <div class="k">投影距离</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1920*1080</div>
                                    <div class="k">分辨率</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '抬头显示器 AR-HUD - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/ARHUD.html'
};

import { createApp } from 'vue';
import App from './ARHUD.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ARHUD.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
